/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Person_Create_Group_LimitInputs */

const fr_person_create_group_limit = /** @type {(inputs: Person_Create_Group_LimitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conservez au maximum 100 périodes par client. Vous pourrez en ajouter après la création.`)
};

const en_person_create_group_limit = /** @type {(inputs: Person_Create_Group_LimitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keep at most 100 periods per client. You can add more after creation.`)
};

/**
* | output |
* | --- |
* | "Keep at most 100 periods per client. You can add more after creation." |
*
* @param {Person_Create_Group_LimitInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const person_create_group_limit = /** @type {((inputs?: Person_Create_Group_LimitInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Person_Create_Group_LimitInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_person_create_group_limit(inputs)
	return fr_person_create_group_limit(inputs)
});